import { addLocaleData } from 'react-intl';
import it from 'react-intl/locale-data/it';

import { setTranslations as setNavTranslations } from '@99designs/globalnav/locale-data';
import navIt from '@99designs/globalnav/locale-data/it';

setNavTranslations(navIt);
addLocaleData(it);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/it.js